import { useState } from 'react';
import dayjs from 'dayjs';
import {
  Box,
  Card,
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  Switch,
} from '@mui/material';
import { GreenOutlinedButton, RedOutlinedButton } from '../../Buttons';
import { LoadingUI } from '../../LayoutStyles';
import { DecisionDialog } from '../../DecisionDialog';
import API from '../../../api';

export default function DatesCard({ dates, isDatesApiCalled, refreshDatesList, canEdit }) {
  const [openUpdateDateDialog, setOpenUpdateDateDialog] = useState(false);
  const [dateToUpdate, setDateToUpdate] = useState(null);

  const handleOpenUpdateDate = (date) => {
    setDateToUpdate(date);
    setOpenUpdateDateDialog(true);
  };

  const handleCloseUpdateDate = () => {
    setDateToUpdate(null);
    setOpenUpdateDateDialog(false);
  };

  const onUpdateDate = (date) => {
    const data = {
      closed: +!date.closed,
    };

    API.put(`/celebration_date/${dateToUpdate.id}`, data).then(() => {
      handleCloseUpdateDate();
      refreshDatesList();
    });
  };

  return (
    <Card
      sx={{
        padding: '24px',
        marginBottom: '24px',
        maxHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5">Date Evento</Typography>
      </Box>

      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Data</TableCell>
            <TableCell>Stato</TableCell>
          </TableRow>
        </TableHead>
      </Table>

      {/* Contenitore scrollabile del corpo tabella */}
      <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
        <TableContainer>
          <Table>
            {isDatesApiCalled ? (
              dates.length > 0 ? (
                <TableBody>
                  {dates.map((date) => (
                    <TableRow key={date.id}>
                      <TableCell component="th" scope="row">
                        {dayjs(date.date).format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell>
                        <Tooltip title={!date.closed ? 'Data Attiva' : 'Data Disattiva'} arrow placement="top">
                          <Box sx={{ width: 'fit-content' }}>
                            <Switch
                              disabled={!canEdit}
                              checked={!date.closed}
                              onChange={() => handleOpenUpdateDate(date)}
                            />
                          </Box>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                      <Typography variant="span">Nessuna Data Assegnata</Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={8}>{LoadingUI()}</TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>

      <DecisionDialog
        openDialog={openUpdateDateDialog}
        dialogTitle="Chiusura data "
        dialogDescription={`Vuoi che la data del ${dayjs(dateToUpdate?.date).format('DD/MM/YYYY')} risulti ${
          dateToUpdate?.closed ? 'aperta' : 'chiusa'
        } al pubblico?`}
        closeOperation={handleCloseUpdateDate}
        requestOperation={() => onUpdateDate(dateToUpdate)}
        requestText={dateToUpdate?.closed ? 'Sì, Attiva' : 'Sì, Disattiva'}
        closeText={'Chiudi'}
        RequestButton={dateToUpdate?.closed ? GreenOutlinedButton : RedOutlinedButton}
      />
    </Card>
  );
}
